import { VisualLayoutState } from '@/features';
import { SS_NAVIGATION_PAYLOAD, SS_VISUAL_LAYOUT_STATE } from '@/constants';

import { RootState } from '../store';

const initialVisibleState = {
  layout: {
    visual: VisualLayoutState.Visible,
    wasOpened: true,
  },
} as const;

type InitialStateBuilderParams = {
  initialLayoutOpenProp?: boolean;
  isEditor: boolean;
  isMobile: boolean;
};

export const initialStateBuilder = ({
  isEditor,
  initialLayoutOpenProp,
  isMobile,
}: InitialStateBuilderParams): Partial<RootState> | undefined => {
  if (isEditor) {
    if (initialLayoutOpenProp) {
      return initialVisibleState;
    }
    return;
  }

  // On mobile we do not restore opened state when navigation happens
  if (
    sessionStorage.getItem(SS_VISUAL_LAYOUT_STATE) ===
      VisualLayoutState.Visible &&
    !isMobile
  ) {
    return initialVisibleState;
  }

  /**
   * On mobile navigation forces visual layout to be minimized.
   * If we have a payload in session storage, it means that the user
   * was navigating before and we need to set flag `wasOpened` to true,
   * so we will fetch conversation history immidiately.
   */

  if (sessionStorage.getItem(SS_NAVIGATION_PAYLOAD)) {
    return {
      layout: {
        visual: VisualLayoutState.Minimized,
        wasOpened: true,
      },
    };
  }

  return undefined;
};
